// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { CSS } from '@dnd-kit/utilities';
import { IconButton } from '@material-ui/core';
import { Edit as EditIcon, Delete as DeleteIcon, DragIndicator as DragIndicatorIcon } from '@material-ui/icons';
import { useSortable } from '@dnd-kit/sortable';

// Internal Dependencies
import MText from '../../../common/MText';
import Colours from '../../../../styles/colours';
import { IsEmpty } from '../../../../common/checks';
import { ParseHtmlIntoReactCom } from '../../../../common/util';

const FaqItem = ({ faq, onUpdate, onDelete, disabled }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: faq.id });

  const cardStyle = {
    transform: !IsEmpty(transform) ? CSS.Translate.toString(transform) : null,
    transition,
  };

  const qnsCom = ParseHtmlIntoReactCom(faq.qns);
  const answerCom = ParseHtmlIntoReactCom(faq.answer);

  return (
    <div
      ref={setNodeRef}
      style={{ ...cardStyle, backgroundColor: Colours.White }}
      className="row mb-2 rounded"
    >
      <div
        style={{ boxShadow: `0 4px 8px 0 ${Colours.Gray4}` }}
        className="col-12 mb-2 d-flex justify-content-between align-items-center rounded-lg pt-4 px-4 pb-2"
      >
        <div>
          <div className="d-flex" style={{ fontSize: 13 }}>
            <MText bold size={13} text="Q:" />
            <div className="ml-2" style={{ paddingTop: 1 }}>
              {qnsCom}
            </div>
          </div>
          <div className="d-flex" style={{ fontSize: 13 }}>
            <MText bold size={13} text="A:" />
            <div className="ml-2" style={{ paddingTop: 1 }}>
              {answerCom}
            </div>
          </div>
        </div>
        {!disabled && (
          <div className="d-flex align-items-center justify-content-end" style={{ gap: 10 }}>
            <IconButton
              size="medium"
              onClick={() => onUpdate({ id: faq.id, qns: faq.qns, answer: faq.answer })}
            >
              <EditIcon htmlColor={Colours.Black} />
            </IconButton>
            <IconButton
              size="medium"
              onClick={() => onDelete({ id: faq.id, qns: faq.qns, answer: faq.answer })}
            >
              <DeleteIcon htmlColor={Colours.Black} />
            </IconButton>
            <IconButton {...attributes} {...listeners} disableRipple size="medium" style={{ cursor: 'move' }}>
              <DragIndicatorIcon htmlColor={Colours.Gray1} />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};

FaqItem.propTypes = {
  faq:      PropTypes.shape(Object).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FaqItem;
